// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"prices-realized-module--videoWrapper--1SIIT","videoSection":"prices-realized-module--videoSection--2d0Ex"};